import * as actionTypes from './actionTypes';
import * as actions from './index';

// **** PROJECT TREE *** //
export const getProjectTreeStart = () => {
    return {
        type: actionTypes.GET_PROJECT_TREE_START
    };
};

export const getProjectTreeSuccess = (children) => {
    return {
        type: actionTypes.GET_PROJECT_TREE_SUCCESS,
        children: children
    };
};

export const getProjectTreeFail = (error) => {
    return {
        type: actionTypes.GET_PROJECT_TREE_FAIL,
        error: error
    };
};

export const getProjectTree = () => {
    return dispatch => {
        dispatch(getProjectTreeStart());
        window.flow.projectGetFullTree(/*[{ field: 'projecttype', type: '!=', value: 'project_delete' }]*/).then(res => {
            dispatch(getProjectTreeSuccess(res.children));
        }).catch(res => {
            dispatch(getProjectTreeFail(res.message));
            dispatch(actions.applicationError(res.message));
        });
    };
};

// **** ADD CHILD PROJECT *** //
export const addProjectChildStart = () => {
    return {
        type: actionTypes.PROJECT_CHILD_ADD_START
    }
};

export const addProjectChildSuccess = (project) => {
    return {
        type: actionTypes.PROJECT_CHILD_ADD_SUCCESS,
        payload: { project: project }
    }
};

export const addProjectChildFail = (error) => {
    return {
        type: actionTypes.PROJECT_CHILD_ADD_FAIL,
        error: error
    }
};

export const addProjectChild = (projectId, title) => {
    return (dispatch => {
        console.log('addProjectChild', projectId, title);
        dispatch(addProjectChildStart());
        window.flow.projectAddNewChild(projectId, { 'name': title }).then(res => {
            // reload projects and  project tree
            dispatch(getProjectTree());
            dispatch(actions.getProjects());
            // new child added
            dispatch(addProjectChildSuccess(res));
        }).catch(res => {
            // unable to add new child
            dispatch(addProjectChildFail(res));
        });
    });
}

